import { LogLevel, LogCategory } from '@/types/logs';

class LoggingService {
  private addLogCallback: ((message: string, level: LogLevel, category: LogCategory, data?: Record<string, unknown>) => void) | null = null;

  setAddLogCallback(callback: (message: string, level: LogLevel, category: LogCategory, data?: Record<string, unknown>) => void) {
    this.addLogCallback = callback;
  }

  log(message: string, level: LogLevel, category: LogCategory, data?: Record<string, unknown>) {
    if (this.addLogCallback) {
      this.addLogCallback(message, level, category, data);
    }
  }
}

export const loggingService = new LoggingService();
